const maintenanceExpirationDefaultFilter = '6-months-fromNow';

const MAINTENANCE_DURATION_UNIT_OPTIONS = [
	{ value: 'days', label: 'Days', isDisabled: true },
	{ value: 'months', label: 'Months' },
	{ value: 'years', label: 'Years', isDisabled: true }
];

export {
	maintenanceExpirationDefaultFilter,
	MAINTENANCE_DURATION_UNIT_OPTIONS
};

